(function () {
  const STORAGE_KEY = 'electricblue_wishlist';
  const CACHE_KEY = 'electricblue_wishlist_products';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  updateButtons();
  updateCounter();
  updateBuyAllButton();
}

  function getProductCache() {
    try {
      return JSON.parse(localStorage.getItem(CACHE_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function saveProductToCache(handle, product) {
  const cache = getProductCache();

  cache[handle] = {
    title: product.title,
    url: product.url,
    price: product.price,
    featured_image: product.featured_image,
    vendor: product.vendor,
    variants: product.variants || [],
    cached_at: Date.now()
  };

  localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
}

  function removeProductFromCache(handle) {
    const cache = getProductCache();

    if (cache[handle]) {
      delete cache[handle];
      localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
    }
  }

  function makeWishlistKey(handle, variantId) {
  return variantId ? handle + '::' + variantId : handle;
}

function getHandleFromKey(key) {
  return String(key || '').split('::')[0];
}

function getVariantIdFromKey(key) {
  const parts = String(key || '').split('::');
  return parts.length > 1 ? parts[1] : null;
}

function isInWishlist(handle, variantId) {
  const key = makeWishlistKey(handle, variantId);
  return getWishlist().includes(key);
}

async function addToWishlist(handle, variantId) {
  const items = getWishlist();
  const key = makeWishlistKey(handle, variantId);

  if (!items.includes(key)) {
    items.push(key);
    saveWishlist(items);
  }

  const product = await loadProduct(handle);
  if (product) {
    saveProductToCache(handle, product);
  }
}

function removeFromWishlist(handle, variantId) {
  const key = makeWishlistKey(handle, variantId);

  const items = getWishlist().filter(function (item) {
    return item !== key;
  });

  saveWishlist(items);
}

function removeWishlistKey(key) {
  const items = getWishlist().filter(function (item) {
    return item !== key;
  });

  saveWishlist(items);
}

async function toggleWishlist(handle, variantId) {
  if (isInWishlist(handle, variantId)) {
    removeFromWishlist(handle, variantId);
  } else {
    await addToWishlist(handle, variantId);
  }
}

  function getProductUrl(handle) {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    return root + 'products/' + handle + '.js';
  }

function formatPrice(price) {
  if (!price) return '';

  return (price / 100).toLocaleString('uk-UA', {
    maximumFractionDigits: 0
  }) + ' ₴';
}

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function renderProductCard(key, product) {
  const handle = getHandleFromKey(key);
  const variantId = getVariantIdFromKey(key);

  const selectedVariant = variantId && product.variants
    ? product.variants.find(function (variant) {
        return String(variant.id) === String(variantId);
      })
    : null;

  const title = escapeHtml(product.title);

  const url = variantId
    ? (product.url || '#') + '?variant=' + variantId
    : product.url || '#';

  const variantOptions = selectedVariant && selectedVariant.options
    ? selectedVariant.options
        .filter(function (option) {
          return option && option !== 'Default Title';
        })
        .map(function (option) {
          return escapeHtml(option);
        })
        .join(' / ')
    : '';

  const price = formatPrice(selectedVariant ? selectedVariant.price : product.price);

  const image = selectedVariant && selectedVariant.featured_image
    ? selectedVariant.featured_image.src
    : product.featured_image || '';

  return `
    <div class="wishlist-card" data-wishlist-item="${escapeHtml(key)}">
      <a class="wishlist-card__image-link" href="${url}">
        ${
          image
            ? `<img class="wishlist-card__image" src="${image}" alt="${title}" loading="lazy">`
            : `<div class="wishlist-card__placeholder"></div>`
        }
      </a>

      <div class="wishlist-card__info">
        <a class="wishlist-card__title" href="${url}">
          ${title}
        </a>

        ${
          variantOptions
            ? `<div class="wishlist-card__variant">${variantOptions}</div>`
            : ''
        }

        <div class="wishlist-card__price">
          ${price}
        </div>

        <div class="wishlist-card__actions">
          <a class="button button--primary button--small" href="${url}">
            Переглянути
          </a>

          <button
            class="wishlist-card__remove"
            type="button"
            data-wishlist-remove="${escapeHtml(key)}"
            aria-label="Видалити зі списку бажань"
            title="Видалити зі списку бажань"
          >
            <svg class="wishlist-card__remove-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M9 3.5h6l1 2h4v2H4v-2h4l1-2Z"></path>
              <path d="M7 9h10l-.8 11.5c-.1 1-1 1.8-2 1.8H9.8c-1 0-1.9-.8-2-1.8L7 9Z"></path>
              <path d="M10 11.5v7M14 11.5v7"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  `;
}

  function updateButtons() {
    document.querySelectorAll('[data-wishlist-button]').forEach(function (button) {
      const handle = button.getAttribute('data-product-handle');
      const variantId = button.getAttribute('data-variant-id');
      const active = isInWishlist(handle, variantId);

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');

      const text = button.querySelector('[data-wishlist-text]');
      if (text) {
        text.textContent = active ? 'У списку бажань' : 'До списку бажань';
      }
    });
  }

  function updateCounter() {
  const count = getWishlist().length;

  document.querySelectorAll('[data-wishlist-count]').forEach(function (counter) {
    counter.textContent = count > 0 ? count : '';
    counter.style.display = count > 0 ? 'inline' : 'none';
  });

  document.querySelectorAll('[data-wishlist-header-link]').forEach(function (link) {
    if (count > 0) {
      link.removeAttribute('hidden');
      link.style.display = 'inline-flex';
    } else {
      link.setAttribute('hidden', 'hidden');
      link.style.display = 'none';
    }
  });
}

  function initWishlistButtons() {
    document.addEventListener('click', function (event) {
      const button = event.target.closest('[data-wishlist-button]');

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      const handle = button.getAttribute('data-product-handle');
const variantId = button.getAttribute('data-variant-id');

if (!handle) return;

toggleWishlist(handle, variantId);
    });

    updateButtons();
    updateCounter();
  }

  async function loadProduct(handle) {
    const response = await fetch(getProductUrl(handle));

    if (!response.ok) return null;

    const product = await response.json();

    saveProductToCache(handle, product);

    return product;
  }

async function renderWishlistPage() {
  const container = document.querySelector('[data-wishlist-grid]');
  const empty = document.querySelector('[data-wishlist-empty]');

  if (!container) return;

  const keys = getWishlist();

  if (typeof updateBuyAllButton === 'function') {
    updateBuyAllButton();
  }

  if (!keys.length) {
    container.innerHTML = '';
    container.classList.remove('is-loading');

    if (empty) empty.style.display = 'block';

    return;
  }

  if (empty) empty.style.display = 'none';

  const cache = getProductCache();

  const missingKeys = keys.filter(function (key) {
    const handle = getHandleFromKey(key);
    return !cache[handle];
  });

if (missingKeys.length) {
  container.classList.add('is-loading');

  await Promise.all(
    missingKeys.map(function (key) {
      const handle = getHandleFromKey(key);
      return loadProduct(handle).catch(function () {
        return null;
      });
    })
  );
}

  const freshCache = getProductCache();

  const html = keys
    .map(function (key) {
      const handle = getHandleFromKey(key);
      const product = freshCache[handle];

      if (!product) return '';

      return renderProductCard(key, product);
    })
    .join('');

  container.classList.remove('is-loading');

  if (html) {
    container.innerHTML = html;
    if (empty) empty.style.display = 'none';
  } else {
    container.innerHTML = '';
    if (empty) empty.style.display = 'block';
  }
}
  function initWishlistPageRemove() {
    document.addEventListener('click', function (event) {
      const button = event.target.closest('[data-wishlist-remove]');

      if (!button) return;

      const key = button.getAttribute('data-wishlist-remove');

      removeWishlistKey(key);
      updateBuyAllButton();
      const card = document.querySelector('[data-wishlist-item="' + key + '"]');
      if (card) card.remove();

      const container = document.querySelector('[data-wishlist-grid]');
      const empty = document.querySelector('[data-wishlist-empty]');

      if (container && !container.querySelector('[data-wishlist-item]')) {
        if (empty) empty.style.display = 'block';
      }
    });
  }

  function updateBuyAllButton() {
  const actions = document.querySelector('[data-wishlist-actions]');
  const buyButton = document.querySelector('[data-wishlist-buy-all]');
  const count = getWishlist().length;
  const hidden = count === 0;

  if (actions) {
    actions.classList.toggle('is-hidden', hidden);
  }

  if (buyButton) {
    buyButton.classList.toggle('is-hidden', hidden);
  }
}

async function buyAllWishlistItems() {
  const button = document.querySelector('[data-wishlist-buy-all]');
  const keys = getWishlist();

  if (!button || !keys.length) return;

  button.disabled = true;
  button.textContent = 'Додаємо...';

  try {
    const products = await Promise.all(
      keys.map(function (key) {
        const handle = getHandleFromKey(key);
        const variantId = getVariantIdFromKey(key);

        return loadProduct(handle)
          .then(function (product) {
            if (!product) return null;

            let variant = null;

            if (variantId && product.variants) {
              variant = product.variants.find(function (item) {
                return String(item.id) === String(variantId);
              });
            }

            if (!variant && product.variants && product.variants.length) {
              variant =
                product.variants.find(function (item) {
                  return item.available;
                }) || product.variants[0];
            }

            if (!variant) return null;

            return {
              id: variant.id,
              quantity: 1
            };
          })
          .catch(function () {
            return null;
          });
      })
    );

    const items = products.filter(Boolean);

    if (!items.length) {
      button.textContent = 'Немає доступних товарів';

      setTimeout(function () {
        button.textContent = 'Купити все';
        button.disabled = false;
      }, 1800);

      return;
    }

    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    const response = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: items
      })
    });

    if (!response.ok) {
      throw new Error('Cart add failed');
    }

    window.location.href = root + 'cart';
  } catch (error) {
    console.error('Wishlist buy all error:', error);

    button.textContent = 'Помилка';

    setTimeout(function () {
      button.textContent = 'Купити все';
      button.disabled = false;
    }, 1800);
  }
}

function initBuyAllWishlist() {
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-wishlist-buy-all]');

    if (!button) return;

    event.preventDefault();
    buyAllWishlistItems();
  });
  updateBuyAllButton();
}
function syncWishlistVariantButtons() {
  document.querySelectorAll('[data-wishlist-button]').forEach(function (button) {
    const form = button.closest('product-info')?.querySelector('form[action*="/cart/add"]');
    const idInput = form ? form.querySelector('input[name="id"]') : null;

    if (idInput && idInput.value) {
      button.setAttribute('data-variant-id', idInput.value);
    }
  });

  updateButtons();
}
  document.addEventListener('DOMContentLoaded', function () {
    initWishlistButtons();
    initWishlistPageRemove();
    initBuyAllWishlist();
    renderWishlistPage();
  syncWishlistVariantButtons();

document.addEventListener('change', function () {
  setTimeout(syncWishlistVariantButtons, 80);
});

document.addEventListener('click', function () {
  setTimeout(syncWishlistVariantButtons, 120);
});
  });

  document.addEventListener('shopify:section:load', function () {
    updateButtons();
    updateCounter();
    renderWishlistPage();
  });
})();